import {
  WorkCategory,
  WorkCategoryFilter,
  WorkFilterOption,
  WorkKind,
  WorkOrder,
  WorkQueueView,
  WorkStatusFilter,
} from "./types";

export const CATEGORY_PARAM = "category";
export const STATUS_PARAM = "status";

export const WORK_CATEGORIES: WorkCategory[] = [
  { kind: "request", label: "Ticker requests", rank: 0 },
  { kind: "instrument", label: "Instrument fixes", rank: 1 },
  { kind: "corporate", label: "Corporate actions", rank: 2 },
];

export const ALL_WORK: WorkFilterOption<WorkCategoryFilter> = {
  value: "all",
  label: "All work",
};

export const STATUS_OPTIONS: WorkFilterOption<WorkStatusFilter>[] = [
  { value: "pending", label: "Pending" },
  { value: "deferred", label: "Deferred" },
  { value: "resolved", label: "Resolved this session" },
  { value: "all", label: "All" },
];

export const ORDER_OPTIONS: WorkFilterOption<WorkOrder>[] = [
  { value: "priority", label: "Priority" },
  { value: "oldest", label: "Oldest first" },
];

export const DEFAULT_VIEW: WorkQueueView = {
  category: "all",
  status: "pending",
  query: "",
  order: "priority",
  selectedKey: null,
};

export const isWorkKind = (value: string | null): value is WorkKind =>
  WORK_CATEGORIES.some(({ kind }) => kind === value);

export const isWorkStatus = (value: string | null): value is WorkStatusFilter =>
  STATUS_OPTIONS.some((option) => option.value === value);
